import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { Btn, H4, Image, LI, UL } from "../../../../../AbstractElements";
import { AddFriend } from "../../../../../Constants/Constants";
import { PeopleKnowData } from "../../../../../Data/Applications/SocialApp/SocialApp";
import { PeopleYouMayKnowProp } from "../../../../../Types/SocialAppType";
import { dynamicImage } from "../../../../../Utils";

const PeopleYouMayKnow:React.FC<PeopleYouMayKnowProp> = ({ heading }) => {
  return (
    <Col sm="12">
      <Card>
        <CardHeader>
          <H4>{heading}</H4>
        </CardHeader>
        <CardBody className="avatar-showcase">
          <div className="pepole-knows">
            <UL className="flex-wrap simple-list flex-row">
              {PeopleKnowData.map((data, index) => (
                <LI key={index}>
                  <div className="add-friend text-center">
                    <Image className="img-60 img-fluid rounded-circle" alt="user" src={dynamicImage(`${data.peopleImageName}`)} />
                    <span className="d-block">{data.peopleName}</span>
                    <Btn color="primary" size="xs">{AddFriend}</Btn>
                  </div>
                </LI>
              ))}
            </UL>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PeopleYouMayKnow;
